import React from 'react';
import LoadingInCenter from '../loading/loading-in-center';

const Btn = (props) => {
  let { disabled, loading, children, loadingFill, type, className, ...others } = props;

  if (loading) {
    // The form has been submitted and is awaiting a response.
    if (type === 'submit') {
      // To prevent resending the form before receiving the current submission response.
      type = 'button';
    }
  }

  return (
    <button type={type} className={className} disabled={disabled} {...others}>
      {loading ? (
        <span className="btn-hide-text" style={{ opacity: 0, padding: 0, margin: 0, border: 'none' }}>
          {children}
        </span>
      ) : (
        children
      )}
      <LoadingInCenter
        show={loading}
        label={'Loading...'}
        width={14}
        height={14}
        fill={loadingFill ? loadingFill : '#ffffff'}
      />
    </button>
  );
};

export default Btn;
